import { render, staticRenderFns } from "./TruckingOrderView.vue?vue&type=template&id=ce1f137a&"
import script from "./TruckingOrderView.vue?vue&type=script&lang=js&"
export * from "./TruckingOrderView.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports